
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $cf55e6d200c95f5c$export$776ced5978d64c37(canvas) {
    let scrollInfo = {
        y: 0,
        x: 0
    };
    let canvasOffsetY = 0;
    function updateScrollY() {
        scrollInfo.y = window.scrollY - canvasOffsetY;
    }
    window.addEventListener("scroll", (e)=>updateScrollY());
    window.addEventListener("resize", (e)=>calculateCanvasOffset());
    function calculateCanvasOffset() {
        canvasOffsetY = canvas.getBoundingClientRect().top + window.scrollY;
        scrollInfo.x = -canvas.getBoundingClientRect().left;
        updateScrollY();
    }
    calculateCanvasOffset();
    return scrollInfo;
}


function $adcfe21ca3ca1826$export$bf5b3774d3a1ba80(canvas) {
    const scrollOffset = (0, $cf55e6d200c95f5c$export$776ced5978d64c37)(canvas);
    const pointerState = {
        x: 0,
        y: 0,
        velX: 0,
        velY: 0,
        prevX: 0,
        prevY: 0,
        isPressed: false,
        _isPressedPrev: false,
        hasPointerUp: false,
        hasPointerDown: false,
        isDragging: false,
        cleanup: cleanup,
        changeCursor: changeCursor,
        hasClicked: false,
        hoveringCollection: null
    };
    function handlePointerMove(e) {
        pointerState.x = e.clientX + scrollOffset.x;
        pointerState.y = e.clientY + scrollOffset.y;
    }
    function handlePointerDown(e) {
        pointerState.isPressed = true;
    }
    function handlePointerUp(e) {
        pointerState.isPressed = false;
    }
    window.addEventListener("pointermove", handlePointerMove);
    window.addEventListener("pointerdown", handlePointerDown);
    window.addEventListener("pointerup", handlePointerUp);
    function cleanup() {
        window.removeEventListener("pointermove", handlePointerMove);
        window.removeEventListener("pointerdown", handlePointerDown);
        window.removeEventListener("pointerup", handlePointerUp);
    }
    let prevCursor = "default";
    function changeCursor(cursor) {
        if (cursor === prevCursor) return;
        document.body.style.cursor = cursor;
        prevCursor = cursor;
    }
    return pointerState;
}
function $adcfe21ca3ca1826$export$bb12a23115d1ed55(pointerState) {
    $adcfe21ca3ca1826$var$updatePressedStates(pointerState);
    // update hoverstate
    if (pointerState.hoveringCollection !== null) pointerState.changeCursor("grab");
    else pointerState.changeCursor("default");
    pointerState.velX = pointerState.x - pointerState.prevX;
    pointerState.velY = pointerState.y - pointerState.prevY;
    pointerState.prevX = pointerState.x;
    pointerState.prevY = pointerState.y;
}
function $adcfe21ca3ca1826$var$updatePressedStates(pointerState) {
    // update drag states first because they should be one tick behind the pressed state
    if (pointerState.isPressed && $adcfe21ca3ca1826$var$isPointerMoving(pointerState, 2)) pointerState.isDragging = true;
    if (pointerState.hasPointerUp) pointerState.isDragging = false;
    pointerState.hasPointerUp = pointerState._isPressedPrev && !pointerState.isPressed;
    pointerState.hasPointerDown = !pointerState._isPressedPrev && pointerState.isPressed;
    pointerState.hasClicked = !pointerState.isDragging && pointerState.hasPointerUp;
    pointerState._isPressedPrev = pointerState.isPressed;
}
function $adcfe21ca3ca1826$var$isPointerMoving(pointerState, threshold) {
    return Math.abs(pointerState.velX) > threshold && Math.abs(pointerState.velY) > threshold;
}


function $ca9a90ae38b877fc$export$57aa011ae8a5616a() {
    const canvas = document.createElement("canvas");
    canvas.width = window.innerWidth;
    canvas.height = 1080;
    canvas.style.display = "block";
    // canvas.style.position = "fixed";
    canvas.style.inset = "0px";
    canvas.style.width = "100vw";
    canvas.style.height = "1080px";
    window.addEventListener("resize", ()=>{
        canvas.width = window.innerWidth;
    // canvas.height = window.innerHeight;
    });
    return canvas;
}


function $ef69b262fafa6326$export$fa1ee8bd071b3aa0({ elm: elm, init: init, update: update }) {
    const canvas = (0, $ca9a90ae38b877fc$export$57aa011ae8a5616a)();
    const context = canvas.getContext("2d");
    // add canvas to document
    elm.appendChild(canvas);
    const renderer = {
        cleanup: cleanup,
        canvas: canvas,
        context: context
    };
    let animFrame = 0;
    let initialParams;
    let isActive = true;
    // init
    function updateFrame() {
        if (!isActive) return;
        renderer.context.clearRect(0, 0, canvas.width, canvas.height);
        // renderer.context.save();
        // renderer.context.scale(2, 2);
        // renderer.context.translate(-canvas.width / 4, -canvas.height / 4);
        update(renderer, initialParams);
        // renderer.context.restore();
        animFrame = requestAnimationFrame(updateFrame);
    }
    async function initCanvas() {
        initialParams = await init(renderer);
        updateFrame();
    }
    initCanvas();
    function cleanup() {
        cancelAnimationFrame(animFrame);
    }
    function resumeUpdateFrame() {
        if (isActive) return;
        isActive = true;
        updateFrame();
    }
    function puaseUpdateFrame() {
        isActive = false;
    }
    // init intersection observer here
    let options = {
        root: document.querySelector("#scrollArea"),
        rootMargin: "0px",
        threshold: [
            0,
            1.0
        ]
    };
    let observer = new IntersectionObserver((e)=>{
        e.forEach((entry)=>{
            if (entry.isIntersecting) {
                // console.log("in view");
                resumeUpdateFrame();
                return;
            }
            // console.log("exit view");
            puaseUpdateFrame();
        });
    }, options);
    observer.observe(canvas);
    return renderer;
}


function $e07c56ea54f165bb$export$c139681dc522a264(point) {
    return {
        x: point.x || 0,
        y: point.y || 0
    };
}
function $e07c56ea54f165bb$export$aa6dea106547860e(point) {
    return {
        x: point.x || 0,
        y: point.y || 0,
        velX: point.velX || 0,
        velY: point.velY || 0,
        prevX: point.prevX || 0,
        prevY: point.prevY || 0
    };
}
function $e07c56ea54f165bb$export$d3ed5a28aad2e372(movablePoint) {
    movablePoint.velX = movablePoint.x - movablePoint.prevX;
    movablePoint.velY = movablePoint.y - movablePoint.prevY;
    movablePoint.prevX = movablePoint.x;
    movablePoint.prevY = movablePoint.y;
}


function $a55bec5aeea31c80$export$442d33069165dc4e() {
    let viewportPos = (0, $e07c56ea54f165bb$export$aa6dea106547860e)({});
    return viewportPos;
}
function $a55bec5aeea31c80$export$b65f3899727324e3(pointer, { canvas: canvas }, viewportAnchor) {
    // if (pointer.isPressed) {
    //   viewportAnchor.velX = pointer.velX;
    //   viewportAnchor.velY = pointer.velY;
    //   viewportAnchor.x += viewportAnchor.velX;
    //   viewportAnchor.y += viewportAnchor.velY;
    // } else {
    //   viewportAnchor.velX = 0;
    //   viewportAnchor.velY = 0;
    // }
    const movementXRange = 20;
    const movementYRange = 20;
    viewportAnchor.x = pointer.x / canvas.width * movementXRange + canvas.width / 2 - movementXRange / 2;
    viewportAnchor.y = pointer.y / canvas.height * movementYRange + canvas.height / 2 - movementYRange / 2;
    (0, $e07c56ea54f165bb$export$d3ed5a28aad2e372)(viewportAnchor);
}


function $28770b279d7ab5b1$export$4ec3b2fd1d2a2980(min = 0, max = 100) {
    // find diff
    let difference = max - min;
    // generate random number
    let rand = Math.random();
    // multiply with difference
    rand = rand * difference;
    // add with min value
    rand = rand + min;
    return rand;
}
function $28770b279d7ab5b1$export$edd0b2047cd8f3e(radius, angle) {
    var x = radius * Math.sin(Math.PI * 2 * angle / 360);
    var y = radius * Math.cos(Math.PI * 2 * angle / 360);
    return {
        x: x,
        y: y
    };
}
function $28770b279d7ab5b1$export$ebc475238af57924(minRad, maxRad) {
    const angle = $28770b279d7ab5b1$export$4ec3b2fd1d2a2980(0, 360);
    const radius = $28770b279d7ab5b1$export$4ec3b2fd1d2a2980(minRad, maxRad);
    return $28770b279d7ab5b1$export$edd0b2047cd8f3e(radius, angle);
}


function $c5d4d333f0c97bd8$export$546f33cfb99892c9(value, targetValue, responsiveness) {
    return value + (targetValue - value) * responsiveness;
}


function $7c4fa47edd0eb717$export$e4369cabd7e84cd9() {
    return `rgba(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255},1)`;
}




function $8b5456fa948592b5$export$270e7ba5936d3c48(config, collection) {
    const node = {
        x: config.x || 0,
        y: config.y || 0,
        centerOffsetX: config.centerOffsetX || 0,
        centerOffsetY: config.centerOffsetY || 0,
        scale: config.scale || 1,
        initialScale: config.initialScale || 1,
        targetScale: config.targetScale || config.initialScale || 1,
        radius: config.radius || 10,
        color: config.color || (0, $7c4fa47edd0eb717$export$e4369cabd7e84cd9)(),
        parentCollection: collection,
        responsiveness: (0, $28770b279d7ab5b1$export$4ec3b2fd1d2a2980)(0.1, 0.02),
        opacity: 1,
        targetOpacity: 1,
        image: config.image,
        label: config.label
    };
    return node;
}
function $8b5456fa948592b5$export$4a08f6218b3019fc(node) {
    // update node
    const parent = node.parentCollection;
    if (!parent) return;
    const dist = (node.centerOffsetX * node.centerOffsetX + node.centerOffsetY * node.centerOffsetY) / 1700;
    const offset = $8b5456fa948592b5$export$fcc110e525a0b28a(node.centerOffsetX, node.centerOffsetY, -dist);
    const targetX = !parent.isExpanded ? parent.x + node.centerOffsetX + offset.x : parent.x + node.centerOffsetX;
    const targetY = !parent.isExpanded ? parent.y + node.centerOffsetY + offset.y : parent.y + node.centerOffsetY;
    // const targetX = parent.x + node.centerOffsetX;
    // const targetY = parent.y + node.centerOffsetY;
    node.x = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(node.x, targetX, node.responsiveness);
    node.y = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(node.y, targetY, node.responsiveness);
    node.scale = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(node.scale, parent.isExpanded ? node.targetScale : 0.5, node.responsiveness);
    node.opacity = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(node.opacity, node.targetOpacity, node.responsiveness);
}
function $8b5456fa948592b5$export$fcc110e525a0b28a(dx, dy, amount) {
    const angle = Math.atan2(dy, dx);
    return {
        x: Math.cos(angle) * amount,
        y: Math.sin(angle) * amount
    };
}
function $8b5456fa948592b5$export$b5942056c8a381c4(node, { context: context }) {
    // render the node here
    context.globalAlpha = node.opacity;
    context.fillStyle = node.color;
    context.beginPath();
    context.arc(node.x, node.y, node.radius * node.scale, 0, 2 * Math.PI);
    context.fill();
    context.globalAlpha = 1;
}


function $f5869366c35a1053$var$withDefault(config, defaultValue) {
    return config !== undefined ? config : defaultValue;
}
function $f5869366c35a1053$export$e363dd855d5a0213(config, parentCollection) {
    const nodes = [];
    const collection = {
        x: $f5869366c35a1053$var$withDefault(config.x, 0),
        y: $f5869366c35a1053$var$withDefault(config.y, 0),
        centerOffsetX: $f5869366c35a1053$var$withDefault(config.centerOffsetX, 0),
        centerOffsetY: $f5869366c35a1053$var$withDefault(config.centerOffsetY, 0),
        scale: $f5869366c35a1053$var$withDefault(config.scale, 1),
        initialScale: $f5869366c35a1053$var$withDefault(config.initialScale, 1),
        radius: $f5869366c35a1053$var$withDefault(config.radius, 10),
        // color: getRandomColor(),
        color: config.image ? $f5869366c35a1053$var$getRGBAString($f5869366c35a1053$var$getAverageRGB(config.image)) : $f5869366c35a1053$var$getParentColour(parentCollection),
        responsiveness: (0, $28770b279d7ab5b1$export$4ec3b2fd1d2a2980)(0.08, 0.14),
        parentCollection: parentCollection,
        isHovering: false,
        isExpanded: config.isExpanded || false,
        canToggleExpandState: $f5869366c35a1053$var$withDefault(config.canToggleExpandState, true),
        showChildrenLink: $f5869366c35a1053$var$withDefault(config.showChildrenLink, false),
        nodes: nodes,
        initialDragOffsetX: 0,
        initialDragOffsetY: 0,
        isLastCollectionLevel: true,
        createNode: function(nodeConfig) {
            const newNode = (0, $8b5456fa948592b5$export$270e7ba5936d3c48)(nodeConfig, collection);
            newNode.x = collection.x;
            newNode.y = collection.y;
            nodes.push(newNode);
            collection.isLastCollectionLevel = true;
            return newNode;
        },
        createNodeCollection: function(config) {
            const nodeCollection = $f5869366c35a1053$export$e363dd855d5a0213(config, collection);
            nodeCollection.x = collection.x;
            nodeCollection.y = collection.y;
            nodes.push(nodeCollection);
            collection.isLastCollectionLevel = false;
            return nodeCollection;
        },
        isDragging: false,
        targetScale: config.targetScale || config.initialScale || 1,
        opacity: 1,
        targetOpacity: 1,
        image: config.image,
        label: config.label
    };
    return collection;
}
function $f5869366c35a1053$var$getAverageRGB(img) {
    const context = document.createElement("canvas").getContext("2d");
    if (typeof img == "string") {
        var src = img;
        img = new Image();
        img.setAttribute("crossOrigin", "");
        img.src = src;
    }
    context.imageSmoothingEnabled = true;
    context.drawImage(img, 0, 0, 1, 1);
    //@ts-ignore
    const rgbArr = context.getImageData(0, 0, 1, 1).data.slice(0, 3);
    return rgbArr;
}
function $f5869366c35a1053$var$varyRGB(rgb, variation = 60) {
    return [
        rgb[0] + Math.random() * variation,
        rgb[1] + Math.random() * variation,
        rgb[2] + Math.random() * variation
    ];
}
function $f5869366c35a1053$var$getRGBAString(rgbArr) {
    return `rgba(${rgbArr[0]}, ${rgbArr[1]}, ${rgbArr[2]}, 1)`;
}
function $f5869366c35a1053$var$getParentColour(parent) {
    if (!parent) return "#FFF";
    if (parent.image) {
        const parentRGB = $f5869366c35a1053$var$getAverageRGB(parent.image);
        const variedRGB = $f5869366c35a1053$var$varyRGB(parentRGB);
        return $f5869366c35a1053$var$getRGBAString(variedRGB);
    }
    if (!parent.parentCollection) return "#FFF";
    return $f5869366c35a1053$var$getParentColour(parent.parentCollection);
}
function $f5869366c35a1053$export$fe599c3bcb8c2b1b(nodeCollection, pointerState, viewportAnchor) {
    if (viewportAnchor) {
        // this is the root node
        nodeCollection.x = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(nodeCollection.x, viewportAnchor.x, 0.1);
        nodeCollection.y = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(nodeCollection.y, viewportAnchor.y, 0.1);
    }
    // update the states
    $f5869366c35a1053$var$updateNodeCollectionHoverState(nodeCollection, pointerState);
    $f5869366c35a1053$var$updateNodeCollectionExpandState(nodeCollection, pointerState);
    $f5869366c35a1053$var$updateNodeCollectionDrag(nodeCollection, pointerState);
    // follow the parent node positions
    if (nodeCollection.isDragging) {
        nodeCollection.x = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(nodeCollection.x, pointerState.x - nodeCollection.initialDragOffsetX, 0.1);
        nodeCollection.y = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(nodeCollection.y, pointerState.y - nodeCollection.initialDragOffsetY, 0.1);
    }
    if (!nodeCollection.isDragging) (0, $8b5456fa948592b5$export$4a08f6218b3019fc)(nodeCollection);
    // snap to mouse
    if (nodeCollection.isHovering) {
        nodeCollection.x = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(nodeCollection.x, nodeCollection.x + (pointerState.x - nodeCollection.x) * 0.5, 0.1);
        nodeCollection.y = (0, $c5d4d333f0c97bd8$export$546f33cfb99892c9)(nodeCollection.y, nodeCollection.y + (pointerState.y - nodeCollection.y) * 0.5, 0.1);
    }
    // update the children nodes
    nodeCollection.nodes.forEach((node)=>{
        // if it were a node collection
        if (node.nodes) {
            $f5869366c35a1053$export$fe599c3bcb8c2b1b(node, pointerState);
            return;
        }
        (0, $8b5456fa948592b5$export$4a08f6218b3019fc)(node);
    });
}
function $f5869366c35a1053$var$updateNodeCollectionExpandState(nodeCollection, pointerState) {
    // handle toggling of expand state
    if (nodeCollection.canToggleExpandState && nodeCollection.isHovering && !nodeCollection.isExpanded) {
        $f5869366c35a1053$var$updateAllParentCollections(nodeCollection, (collection)=>{
            collection.isExpanded = true;
        });
        $f5869366c35a1053$var$updateOtherNodeCollections(nodeCollection, (collection)=>{
            if (!collection.canToggleExpandState) return;
            collection.isExpanded = false;
        });
    }
// if (
//   nodeCollection.canToggleExpandState &&
//   !nodeCollection.isHovering &&
//   nodeCollection.isExpanded
// ) {
//   nodeCollection.isExpanded = false;
//   updateChildrenNodeCollections(nodeCollection, (collection) => {
//     if (!collection.canToggleExpandState) return;
//     collection.isExpanded = false;
//   });
// }
// if (
//   nodeCollection.canToggleExpandState &&
//   nodeCollection.isHovering &&
//   pointerState.hasClicked
// ) {
//   nodeCollection.isExpanded = !nodeCollection.isExpanded;
//   // collapse other node collection
//   // close all children
//   if (!nodeCollection.isExpanded) {
//     updateChildrenNodeCollections(nodeCollection, (collection) => {
//       if (!collection.canToggleExpandState) return;
//       collection.isExpanded = false;
//     });
//   }
//   // close unrelated collections
//   if (nodeCollection.isExpanded) {
//     updateOtherNodeCollections(nodeCollection, (collection) => {
//       if (!collection.canToggleExpandState) return;
//       collection.isExpanded = false;
//     });
//   }
// }
}
function $f5869366c35a1053$var$updateAllParentCollections(self, callback) {
    callback(self);
    if (!self.parentCollection) return;
    $f5869366c35a1053$var$updateAllParentCollections(self.parentCollection, callback);
}
function $f5869366c35a1053$var$updateOtherNodeCollections(self, callback, notIncludeOwnChildren = false) {
    const traverseUpwardAndCollapseOtherBranches = (self, prevNode)=>{
        if (!self.nodes) return;
        self.nodes.forEach((node)=>{
            if (notIncludeOwnChildren && prevNode === undefined) return;
            if (node === prevNode) return;
            $f5869366c35a1053$var$updateChildrenNodeCollections(node, callback);
        });
        // continue traverse upwards when it doesn't hit the root node
        if (!self.parentCollection) return;
        traverseUpwardAndCollapseOtherBranches(self.parentCollection, self);
    };
    traverseUpwardAndCollapseOtherBranches(self, undefined);
}
function $f5869366c35a1053$var$updateChildrenNodeCollections(collection, callback) {
    callback(collection);
    if (collection.isLastCollectionLevel) return;
    if (!collection.nodes) return;
    collection.nodes.forEach((node)=>{
        if (!node.nodes) return;
        $f5869366c35a1053$var$updateChildrenNodeCollections(node, callback);
    });
}
function $f5869366c35a1053$var$updateNodeCollectionHoverState(nodeCollection, pointerState) {
    const isWithinNode = $f5869366c35a1053$export$4409ca3071bc839d(pointerState.x, pointerState.y, nodeCollection);
    const okayToHover = pointerState.hoveringCollection === null || pointerState.hoveringCollection === nodeCollection;
    if (isWithinNode && okayToHover && !nodeCollection.isHovering) {
        $f5869366c35a1053$var$onEnterHover(nodeCollection);
        nodeCollection.isHovering = true;
    }
    if (!isWithinNode && nodeCollection.isHovering) {
        $f5869366c35a1053$var$onExitHover(nodeCollection);
        nodeCollection.isHovering = false;
    }
    if (nodeCollection.isHovering) pointerState.hoveringCollection = nodeCollection;
    // clean up when no longer hovering
    if (!nodeCollection.isHovering && pointerState.hoveringCollection === nodeCollection) pointerState.hoveringCollection = null;
}
function $f5869366c35a1053$var$onEnterHover(nodeCollection) {
    nodeCollection.targetScale = nodeCollection.initialScale * 1.1;
    $f5869366c35a1053$var$updateOtherNodeCollections(nodeCollection, (collection)=>{
        collection.targetOpacity = 0.2;
    }, true);
}
function $f5869366c35a1053$var$onExitHover(nodeCollection) {
    nodeCollection.targetScale = nodeCollection.initialScale;
    $f5869366c35a1053$var$updateOtherNodeCollections(nodeCollection, (collection)=>{
        collection.targetOpacity = 1;
    });
}
function $f5869366c35a1053$var$updateNodeCollectionDrag(nodeCollection, pointerstate) {
    if (pointerstate.hasPointerDown && nodeCollection.isHovering) {
        nodeCollection.isDragging = true;
        nodeCollection.initialDragOffsetX = pointerstate.x - nodeCollection.x;
        nodeCollection.initialDragOffsetY = pointerstate.y - nodeCollection.y;
    }
    if (pointerstate.hasPointerUp) nodeCollection.isDragging = false;
}
function $f5869366c35a1053$export$4409ca3071bc839d(x, y, node) {
    return Math.pow(node.x - x, 2) + Math.pow(node.y - y, 2) < Math.pow(node.radius, 2);
}
function $f5869366c35a1053$export$d16818ab5fd4fa71(nodeCollection, canvasRenderer) {
    const context = canvasRenderer.context;
    // render the line to each collection
    if (nodeCollection.showChildrenLink) nodeCollection.nodes.forEach((node)=>{
        context.fillStyle = "#CCC";
        context.strokeStyle = nodeCollection.isExpanded ? "#CCC" : "rgba(0,0,0,0)";
        context.beginPath();
        context.moveTo(nodeCollection.x, nodeCollection.y);
        context.lineTo(node.x, node.y);
        context.stroke();
    });
    // render the node collection here
    nodeCollection.nodes.forEach((node)=>{
        // if it were a node collection
        if (node.nodes) {
            $f5869366c35a1053$export$d16818ab5fd4fa71(node, canvasRenderer);
            return;
        }
        (0, $8b5456fa948592b5$export$b5942056c8a381c4)(node, canvasRenderer);
    });
    // render the node here
    context.beginPath();
    context.arc(nodeCollection.x, nodeCollection.y, nodeCollection.radius * nodeCollection.scale, 0, 2 * Math.PI);
    const isParentExpanded = !nodeCollection.parentCollection || nodeCollection.parentCollection?.isExpanded;
    context.globalAlpha = nodeCollection.opacity;
    context.fillStyle = "#FFF";
    context.fill();
    // context.fillStyle = nodeCollection.isHovering
    //   ? "#999"
    //   : `rgba(180,180,180,${nodeCollection.opacity})`;
    context.fillStyle = nodeCollection.image ? "#FFF" : nodeCollection.color;
    // context.strokeStyle = "#CCC";
    context.fill();
    // context.stroke();
    context.closePath();
    context.globalAlpha = 1;
    if (nodeCollection.image) {
        context.globalAlpha = nodeCollection.opacity;
        canvasRenderer.context.drawImage(nodeCollection.image, nodeCollection.x - nodeCollection.radius, nodeCollection.y - nodeCollection.radius, nodeCollection.radius * 2, nodeCollection.radius * 2);
        context.globalAlpha = 1;
    }
}
let $f5869366c35a1053$var$roundRect = (ctx, x0, y0, x1, y1, r, color)=>{
    var w = x1 - x0;
    var h = y1 - y0;
    if (r > w / 2) r = w / 2;
    if (r > h / 2) r = h / 2;
    ctx.beginPath();
    ctx.moveTo(x1 - r, y0);
    ctx.quadraticCurveTo(x1, y0, x1, y0 + r);
    ctx.lineTo(x1, y1 - r);
    ctx.quadraticCurveTo(x1, y1, x1 - r, y1);
    ctx.lineTo(x0 + r, y1);
    ctx.quadraticCurveTo(x0, y1, x0, y1 - r);
    ctx.lineTo(x0, y0 + r);
    ctx.quadraticCurveTo(x0, y0, x0 + r, y0);
    ctx.closePath();
    ctx.fillStyle = color;
    ctx.fill();
};
function $f5869366c35a1053$export$23adae1c558f4ea5(nodeCollection, canvasRenderer) {
    if (nodeCollection.label && nodeCollection.isHovering) {
        const textPositionX = nodeCollection.x + nodeCollection.radius + 10;
        const fontSize = 16;
        const textWidth = canvasRenderer.context.measureText(nodeCollection.label).width;
        const paddingX = 8;
        $f5869366c35a1053$var$roundRect(canvasRenderer.context, textPositionX, nodeCollection.y - fontSize * 1, textPositionX + textWidth + paddingX + paddingX, nodeCollection.y + fontSize * 1, 64, "#EEE");
        canvasRenderer.context.fillStyle = "#333";
        canvasRenderer.context.font = `${fontSize}px 'Nb International Pro', sans-serif`;
        canvasRenderer.context.fillText(nodeCollection.label, textPositionX + paddingX, nodeCollection.y + fontSize * 0.45);
    }
    if (!nodeCollection.nodes) return;
    nodeCollection.nodes.forEach((node)=>$f5869366c35a1053$export$23adae1c558f4ea5(node, canvasRenderer));
}



var $ff619b5ad0e129c8$exports = {};
$ff619b5ad0e129c8$exports = JSON.parse('{"nodes":[{"id":"Superpower","group":1,"desc":"","value":120,"img":"superpower.png","imageBool":true,"color":"grey","neighbors":[]},{"id":"Physical Health","group":1,"desc":"The state of well-being where all body systems and organs function optimally, free from disease, and are properly conditioned through regular exercise, movement, and maintenance. Superpower defines Physical Health as your physical fitness, your Physiological Health, Genetics, and Disease Risk.","value":75,"img":"physical-health.png","imageBool":true,"color":"grey","neighbors":[]},{"id":"Mental Health","group":2,"desc":"The balance of psychological, emotional, and social well-being, critical for personal resilience, coping mechanisms, and overall cognitive function.","value":75,"img":"mental-health.png","imageBool":true,"color":"grey","neighbors":[]},{"id":"Environment","group":2,"desc":"The external factors affecting your health, including the physical, social, and chemical aspects of your surroundings. Common environmental exposures that may influence your health include air quality, water quality, chemicals, fungi, toxins, pollutants, and electromagnetic fields.","value":75,"img":"environment.png","imageBool":true,"color":"grey","neighbors":[]},{"id":"Sleep","group":2,"desc":"The restorative state of body and mind that contributes to overall health by allowing for the healing and rejuvenation of various body functions.","value":75,"img":"sleep.png","imageBool":true,"color":"grey","neighbors":[]},{"id":"Nutrition","group":2,"desc":"The provision of essential nutrients to the body through balanced diet and lifestyle, fundamental for the body\'s growth, repair, and maintenance.","value":75,"img":"nutrition.png","imageBool":true,"color":"grey","neighbors":[]},{"id":"Physical Fitness","group":2,"desc":"Your ability to perform daily physically demanding activities effectively.","value":25,"img":"physical-fitness.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Physiological Health","group":2,"desc":"Physiological health refers to the optimal functioning of your bodily systems and processes, such as your organs, nervous system, immune response, and hormonal balance.","value":25,"img":"physiological-health.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Genetics","group":2,"desc":"Your germline genetic screening and family history evaluation for susceptibility to diseases or phenotypical dysfunctions.","value":25,"img":"genetics.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Disease Risk","group":2,"desc":"The predisposition or vulnerability for you to develop physiological disorders.","value":25,"img":"disease-risk.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Emotional Well-being","group":2,"desc":"Emotional well-being relates to your ability to effectively manage and express your emotions in a healthy manner. It encompasses feelings of happiness, sadness, anxiety, as well as the capacity to cope with life\'s challenges in a constructive way.","value":25,"img":"emotional-well-being.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Cognitive Function","group":2,"desc":"Mental capabilities that are required for the processing of information, decision-making, problem-solving, learning, and memory. Optimal cognitive function ensures that you can think clearly, remember information, and engage in logical reasoning.","value":25,"img":"cognitive-function.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Stress Management","group":2,"desc":"Stress Management refers to your strategies, coping mechanisms, and techniques to handle or mitigate stress in life.","value":25,"img":"stress-management.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Spirituality and Purpose","group":2,"desc":"A sense of meaning and purpose in life, whether through personal beliefs, values, or a broader sense of connection to the universe or a higher power.","value":25,"img":"spirituality-and-purpose.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Community, Relationships, and Social Satisfaction","group":2,"desc":"The quality and depth of your social connections \u2013 including friendships, family and romantic ties, as well as community involvement.","value":25,"img":"community-relationships-and-social-satisfaction.png","imageBool":true,"color":"black","neighbors":[]},{"id":"subconscious work and understanding your \'inner child\'","group":2,"desc":"Inner work is the intentional and conscientious practice of unraveling and examining your motives, fixations, and subconscious programming.","value":25,"img":"subconscious-work-and-understanding-your-inner-child.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Physical Environment","group":2,"desc":"The physical environment refers to the tangible external factors and conditions that surround you, which can influence your physiological and biochemical health processes. This includes elements like air quality, water quality, exposure to toxins or pollutants, access to clean foods, radiation levels, and other external factors that can either support or hinder optimal health. A well-balanced physical environment promotes health by minimizing exposures to harmful elements and maximizing beneficial ones.","value":25,"img":"physical-environment.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Social Environment","group":2,"desc":"The social environment encompasses the intricate web of relationships, social structures, cultural norms, and interactions that you are embedded in. This includes family dynamics, friendships, work relationships, community ties, and broader societal factors. A supportive social environment can foster emotional well-being, reduce stress, and provide networks for sharing health-promoting resources and information. On the flip side, negative or toxic social environments can lead to increased stress, feelings of isolation, and negative health outcomes.","value":25,"img":"social-environment.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Diet","group":2,"desc":"The foods, supplements, and liquids you are consuming on a daily basis (measured by calories, macro and micronutrient type, and any associated toxin levels).","value":25,"img":"diet.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Macronutrient","group":2,"desc":"Macronutrients are the primary nutrients that your body needs in large amounts to function properly. The three primary macronutrients are carbohydrates, proteins, and fats.","value":25,"img":"macronutrient.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Micronutrient","group":2,"desc":"Micronutrients are essential vitamins, minerals, and antioxidant stores required by your body in small amounts for proper growth, development, and physiological functioning. Though required in minute quantities, their absence or deficiency can lead to significant health problems.","value":25,"img":"micronutrient.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Gut Health","group":2,"desc":"Gut health refers to the balance and well-being of the microbiota (bacteria and other microorganisms) present in your digestive tracts, as well as the strength, integrity, and inflammation levels of your intestinal walls that separate the digestive tract from your bloodstream and other organs.","value":25,"img":"gut-health.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Allergies","group":2,"desc":"Allergies are hypersensitive immune responses of your body to substances that either enter or come into contact with it. Common allergens include foods and environmental triggers like pollen.","value":25,"img":"allergies.png","imageBool":true,"color":"black","neighbors":[]},{"id":"Hydration","group":2,"desc":"Hydration refers to the process of absorbing water into your body\'s cells. Proper hydration is crucial for maintaining bodily functions, including cognition, movement, regulating temperature, digesting food, and expelling waste.","value":25,"img":"hydration.png","imageBool":false,"color":"black","neighbors":[]},{"id":"Sleep Quality","group":2,"desc":"Sleep quality pertains to how well you sleep and the restfulness of that sleep. It includes factors like how long it takes to fall asleep, the number of awakenings during the night, and the proportion of actual sleep time during the sleep period.","value":25,"img":"sleep-quality.png","imageBool":false,"color":"black","neighbors":[]},{"id":"Sleep Duration","group":2,"desc":"Sleep duration refers to the total amount of time that you spend sleeping in a 24-hour period.","value":25,"img":"sleep-duration.png","imageBool":false,"color":"black","neighbors":[]},{"id":"Sleep Disorders","group":2,"desc":"Sleep disorders are conditions that disrupt the normal sleep patterns, leading to difficulties in falling asleep, staying asleep, or getting restorative sleep. Examples include insomnia, sleep apnea, restless leg syndrome, and narcolepsy.","value":25,"img":"sleep-disorders.png","imageBool":false,"color":"black","neighbors":[]},{"id":"Metabolism","group":2,"desc":"The biochemical process by which your body converts what you eat and drink into energy. Measured by biomarkers like fasting glucose, average blood sugar (HgbA1c), insulin, and advanced cholesterol biomarkers.","value":6,"imageBool":false,"color":"grey","img":"metabolism.png","neighbors":[]},{"id":"Body Composition","group":-1,"desc":"The relative amounts of muscle, fat, bone, and other vital parts of your body. It is usually expressed as a ratio of lean mass to fat mass.","value":6,"imageBool":false,"color":"grey","img":"body-composition.png","neighbors":[]},{"id":"Flexibility","group":-1,"desc":"Flexibility is the ability of your joint or series of joints to move through an unrestricted, pain-free range of motion. Balance, on the other hand, is your ability to maintain the body\'s position over its base of support within stability limits, both statically and dynamically.","value":6,"imageBool":false,"color":"grey","img":"flexibility.png","neighbors":[]},{"id":"Muscular Strength","group":-1,"desc":"The maximum amount of force that your muscle or group of your muscles can exert against some form of resistance in a single effort.","value":6,"imageBool":false,"color":"grey","img":"muscular-strength.png","neighbors":[]},{"id":"Cardiovascular Endurance","group":-1,"desc":"The ability of your heart and lungs to supply oxygen-rich blood to the working muscle tissues and the capacity of the muscles to use oxygen to produce energy for movement over sustained periods of time.","value":6,"imageBool":false,"color":"grey","img":"cardiovascular-endurance.png","neighbors":[]},{"id":"Cardiometabolic","group":-1,"desc":"Cardiometabolic labs are tests that measure the levels of certain substances in your blood that are related to your heart and metabolic health. They are important because they can help you assess your risk of developing cardiovascular disease, diabetes, or other cardiometabolic conditions, and guide you in making lifestyle changes or taking medications to prevent or treat them.","value":6,"imageBool":false,"color":"grey","img":"cardiometabolic.png","neighbors":[]},{"id":"Heart Health (Cardiovascular Risk)","group":-1,"desc":"Heart Health and Cardiovascular risk is the probability of developing or dying from a heart or blood vessel disease, such as heart attack or stroke, over a certain period of time.","value":6,"imageBool":false,"color":"grey","img":"heart-health-cardiovascular-risk.png","neighbors":[]},{"id":"Liver Health","group":-1,"desc":"The state of having a liver that performs its essential functions well, such as filtering toxins, producing bile, metabolizing nutrients, and regulating blood clotting.","value":6,"imageBool":false,"color":"grey","img":"liver-health.png","neighbors":[]},{"id":"Kidney Health","group":-1,"desc":"The state of having kidneys that perform their essential functions well, such as filtering waste, producing hormones, and maintaining fluid and electrolyte balance.","value":6,"imageBool":false,"color":"grey","img":"kidney-health.png","neighbors":[]},{"id":"Immune Health","group":-1,"desc":"The state of having a well-functioning immune system that can protect the body from infections, diseases, and other harmful agents.","value":6,"imageBool":false,"color":"grey","img":"immune-health.png","neighbors":[]},{"id":"Skeletal and Bone Health","group":-1,"desc":"The state of having a strong and healthy skeletal system that supports the body, protects the organs, and enables movement.","value":6,"imageBool":false,"color":"grey","img":"skeletal-and-bone-health.png","neighbors":[]},{"id":"Blood and Oxygen","group":-1,"desc":"Blood and oxygen health are the aspects of the body system that involve the delivery and utilization of oxygen by the cells and tissues.","value":6,"imageBool":false,"color":"grey","img":"blood-and-oxygen.png","neighbors":[]},{"id":"Hormone Health","group":-1,"desc":"The aspect of the body system that involves the production, regulation, and function of hormones, which are chemical messengers that coordinate different processes in your body.","value":6,"imageBool":false,"color":"grey","img":"hormone-health.png","neighbors":[]},{"id":"Skin, Hair, and Nails Health","group":-1,"desc":"Skin, hair, and nail health are the aspects of the body system that involve the structure, function, and maintenance of the skin, hair, and nails.","value":6,"imageBool":false,"color":"grey","img":"skin-hair-and-nails-health.png","neighbors":[]},{"id":"Nervous System Health","group":-1,"desc":"The nervous system is the part of the body that coordinates and controls all the activities of the body, such as sensing, thinking, moving, and feeling.","value":6,"imageBool":false,"color":"grey","img":"nervous-system-health.png","neighbors":[]},{"id":"Oral and Dental Health","group":-1,"desc":"Oral and dental health are the state of your mouth, teeth, gums, and oral microbiome and are important for your overall health and well-being.","value":6,"imageBool":false,"color":"grey","img":"oral-and-dental-health.png","neighbors":[]},{"id":"Germline Disease Risk","group":-1,"desc":"Germline disease risk is the likelihood of developing a disease or disorder that is inherited from one or both parents through the genes present in the egg or sperm cells.","value":6,"imageBool":false,"color":"grey","img":"germline-disease-risk.png","neighbors":[]},{"id":"Pharmacogenetics","group":-1,"desc":"Pharmacogenetics is the study of how genetic variations affect the response and metabolism of drugs in different individuals.","value":6,"imageBool":false,"color":"grey","img":"pharmacogenetics.png","neighbors":[]},{"id":"Nutritional Absorption","group":-1,"desc":"Nutrition absorption related to your genetics is the influence of your genetic makeup on how well you can absorb and utilize the nutrients from your diet.","value":6,"imageBool":false,"color":"grey","img":"nutritional-absorption.png","neighbors":[]},{"id":"Epigenetic Age Clocks","group":-1,"desc":"Mathematical models that estimate the biological age of an individual based on the patterns of DNA methylation, which is a chemical modification of the DNA that can affect gene expression.","value":6,"imageBool":false,"color":"grey","img":"epigenetic-age-clocks.png","neighbors":[]},{"id":"Cancer","group":-1,"desc":"Cancer is a group of diseases that involve the abnormal growth and spread of cells that can damage normal tissues and organs.","value":6,"imageBool":false,"color":"grey","img":"cancer.png","neighbors":[]},{"id":"Depression","group":-1,"desc":"Depression is a common and can be serious mental health condition that affects the mood, thoughts, and behavior of a person.","value":6,"imageBool":false,"color":"grey","img":"depression.png","neighbors":[]},{"id":"Anxiety","group":-1,"desc":"Anxiety is a common and complex mental health condition that affects the emotions, thoughts, and behavior of a person.","value":6,"imageBool":false,"color":"grey","img":"anxiety.png","neighbors":[]},{"id":"Happiness and Satisfaction","group":-1,"desc":"Happiness and satisfaction are the aspects of the mental and emotional well-being that involve the positive feelings and attitudes that a person has towards oneself and one\u2019s life.","value":6,"imageBool":false,"color":"grey","img":"happiness-and-satisfaction.png","neighbors":[]},{"id":"Memory","group":-1,"desc":"The aspect of the cognitive function that involves the encoding, storage, and retrieval of information in the brain.","value":6,"imageBool":false,"color":"grey","img":"memory.png","neighbors":[]},{"id":"Focus and Attention","group":-1,"desc":"Aspects of the cognitive function that involve the selection, concentration, and maintenance of awareness on a specific stimulus or task","value":6,"imageBool":false,"color":"grey","img":"focus-and-attention.png","neighbors":[]},{"id":"Productivity","group":-1,"desc":"Productivity is the aspect of the personal and professional performance that involves the efficiency, quality, and quantity of the output or outcome of a given task or goal.","value":6,"imageBool":false,"color":"grey","img":"productivity.png","neighbors":[]},{"id":"Air Quality","group":-1,"desc":"Air quality is the aspect of the environmental health that involves the level of pollutants and contaminants in the air that we breathe.","value":6,"imageBool":false,"color":"grey","img":"air-quality.png","neighbors":[]},{"id":"Water Quality","group":-1,"desc":"Water quality is the aspect of the environmental health that involves the level of pollutants and contaminants in the water that we drink, use, and interact with.","value":6,"imageBool":false,"color":"grey","img":"water-quality.png","neighbors":[]},{"id":"Allergen Exposure","group":-1,"desc":"Allergen exposure is the aspect of your environmental health that involves the contact or ingestion of substances that can trigger an allergic reaction in some individuals.","value":6,"imageBool":false,"color":"grey","img":"allergen-exposure.png","neighbors":[]},{"id":"Toxin Exposure","group":-1,"desc":"Toxin exposure is the aspect of your environmental health that involves the contact or ingestion of substances that can harm the cells, organs, or systems of the body.","value":6,"imageBool":false,"color":"grey","img":"toxin-exposure.png","neighbors":[]},{"id":"Bacterial Exposure","group":-1,"desc":"Bacterial exposure is the aspect of your environmental health that involves the contact or ingestion of microorganisms that can cause infections or diseases in some individuals.","value":6,"imageBool":false,"color":"grey","img":"bacterial-exposure.png","neighbors":[]},{"id":"Community","group":-1,"desc":"Community is the aspect of your social environment that involves the sense of belonging, connection, and support that a person has with other people who share common values, interests, or goals.","value":6,"imageBool":false,"color":"grey","img":"community.png","neighbors":[]},{"id":"Friends","group":-1,"desc":"Friends are the aspect of your social environment that involve the people who you have a close, personal, and positive relationship with.","value":6,"imageBool":false,"color":"grey","img":"friends.png","neighbors":[]},{"id":"Family relationships","group":-1,"desc":"Family relationships are the aspect of your social environment that involve the people who you are related to by blood, marriage, or adoption. Family relationships can provide you with love, care, guidance, and support. Family relationships can also influence your health, happiness, and behavior.","value":6,"imageBool":false,"color":"grey","img":"family-relationships.png","neighbors":[]},{"id":"Intimate relationships","group":-1,"desc":"Intimate relationships are the aspect of your social environment  that involve the people who you have a close, personal, and romantic connection with. Intimate relationships can provide you with affection, intimacy, sexual satisfaction, and emotional support. Intimate relationships can also influence your health, happiness, and behavior.","value":6,"imageBool":false,"color":"grey","img":"intimate-relationships.png","neighbors":[]},{"id":"Protein intake","group":-1,"desc":"The aspect of nutrition that involves the amount and quality of the protein that you consume from your diet, which is an essential macronutrient that provides amino acids, which are the building blocks of the body\u2019s tissues, enzymes, hormones, and antibodies.","value":6,"imageBool":false,"color":"grey","img":"protein-intake.png","neighbors":[]},{"id":"Carbohydrate intake","group":-1,"desc":"The aspect of nutrition that involves the amount and quality of the carbohydrate that you consume from your diet, which is an essential macronutrient that provides glucose, which is the main source of energy for the brain and muscles.","value":6,"imageBool":false,"color":"grey","img":"carbohydrate-intake.png","neighbors":[]},{"id":"Fat intake","group":-1,"desc":"The aspect of nutrition that involves the amount and quality of the carbohydrate that you consume from your diet, which is an essential macronutrient that provides fatty acids, which are the building blocks of the cell membranes, hormones, and signaling molecules.","value":6,"imageBool":false,"color":"grey","img":"fat-intake.png","neighbors":[]},{"id":"Vitamins","group":-1,"desc":"Vitamins are organic compounds that are essential for various biochemical processes in the body, but cannot be synthesized by the body itself and must be obtained from dietary sources or supplements.","value":6,"imageBool":false,"color":"grey","img":"vitamins.png","neighbors":[]},{"id":"Minerals","group":-1,"desc":"Minerals are inorganic elements that are involved in various structural and functional roles in the body, such as building bones and teeth, regulating fluid balance and enzyme activity, and transmitting nerve impulses.","value":6,"imageBool":false,"color":"grey","img":"minerals.png","neighbors":[]},{"id":"Omegas","group":-1,"desc":"A group of essential fatty acids that have various health benefits for the body, such as reducing inflammation, improving brain function, and lowering the risk of cardiovascular disease.","value":6,"imageBool":false,"color":"grey","img":"omegas.png","neighbors":[]},{"id":"Antioxidants","group":-1,"desc":"Substances that protect your cells from the harmful effects of free radicals, which are unstable molecules that can cause damage to your DNA and other important molecules. Antioxidants can be found in many foods, especially fruits and vegetables, or taken as supplements.","value":6,"imageBool":false,"color":"grey","img":"antioxidants.png","neighbors":[]},{"id":"Organic Acids","group":-1,"desc":"Organic acids are products of your body\'s metabolism that can be measured in your urine to assess your functional health, such as your nutrient status, inflammation level, gut function, and mitochondrial function.","value":6,"imageBool":false,"color":"grey","img":"organic-acids.png","neighbors":[]},{"id":"Microbiome Diversity","group":-1,"desc":"Microbiome diversity is the measure of how many different types of microbes live in a certain environment, such as the human gut, skin, or mouth and can influence many aspects of your physiology, immunity, metabolism, and behavior.","value":6,"imageBool":false,"color":"grey","img":"microbiome-diversity.png","neighbors":[]},{"id":"Intestinal Wall Permeability","group":-1,"desc":"The ability of substances to pass through the lining of the small and large intestines into the bloodstream.","value":6,"imageBool":false,"color":"grey","img":"intestinal-wall-permeability.png","neighbors":[]},{"id":"Intestinal Inflammation","group":-1,"desc":"Intestinal inflammation is a condition where the lining of the small or large intestine becomes irritated, swollen, and damaged due to various factors, such as infections, autoimmune diseases, or medications.","value":6,"imageBool":false,"color":"grey","img":"intestinal-inflammation.png","neighbors":[]},{"id":"Antibody testing","group":-1,"desc":"Antibody testing is a way of measuring how your immune system reacts to certain substances, called allergens, that may cause symptoms such as itching, rashes, and GI symptoms with certain foods.","value":6,"imageBool":false,"color":"grey","img":"antibody-testing.png"}],"links":[{"source":"Superpower","target":"Physical Health","value":2,"curvature":0.25},{"source":"Superpower","target":"Mental Health","value":2,"curvature":0.25},{"source":"Superpower","target":"Environment","value":2,"curvature":0.25},{"source":"Superpower","target":"Sleep","value":2,"curvature":0.25},{"source":"Superpower","target":"Nutrition","value":2,"curvature":0.25},{"source":"Physical Health","target":"Physical Fitness","value":2,"curvature":0.25},{"source":"Physical Health","target":"Physiological Health","value":2,"curvature":0.25},{"source":"Physical Health","target":"Genetics","value":2,"curvature":0.25},{"source":"Physical Health","target":"Disease Risk","value":2,"curvature":0.25},{"source":"Mental Health","target":"Emotional Well-being","value":2,"curvature":0.25},{"source":"Mental Health","target":"Cognitive Function","value":2,"curvature":0.25},{"source":"Mental Health","target":"Stress Management","value":2,"curvature":0.25},{"source":"Mental Health","target":"Spirituality and Purpose","value":2,"curvature":0.25},{"source":"Mental Health","target":"Community, Relationships, and Social Satisfaction","value":2,"curvature":0.25},{"source":"Mental Health","target":"subconscious work and understanding your \'inner child\'","value":2,"curvature":0.25},{"source":"Environment","target":"Physical Environment","value":2,"curvature":0.25},{"source":"Environment","target":"Social Environment","value":2,"curvature":0.25},{"source":"Nutrition","target":"Diet","value":2,"curvature":0.25},{"source":"Nutrition","target":"Macronutrient","value":2,"curvature":0.25},{"source":"Nutrition","target":"Micronutrient","value":2,"curvature":0.25},{"source":"Nutrition","target":"Gut Health","value":2,"curvature":0.25},{"source":"Nutrition","target":"Allergies","value":2,"curvature":0.25},{"source":"Nutrition","target":"Hydration","value":2,"curvature":0.25},{"source":"Sleep","target":"Sleep Quality","value":2,"curvature":0.25},{"source":"Sleep","target":"Sleep Duration","value":2,"curvature":0.25},{"source":"Sleep","target":"Sleep Disorders","value":2,"curvature":0.25},{"source":"Physical Fitness","target":"Metabolism","value":3,"curvature":0.25},{"source":"Physical Fitness","target":"Body Composition","value":3,"curvature":0.25},{"source":"Physical Fitness","target":"Flexibility","value":3,"curvature":0.25},{"source":"Physical Fitness","target":"Muscular Strength","value":3,"curvature":0.25},{"source":"Physical Fitness","target":"Cardiovascular Endurance","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Heart Health (Cardiovascular Risk)","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Liver Health","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Kidney Health","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Immune Health","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Skeletal and Bone Health","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Blood and Oxygen","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Hormone Health","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Skin, Hair, and Nails Health","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Nervous System Health","value":3,"curvature":0.25},{"source":"Physiological Health","target":"Oral and Dental Health","value":3,"curvature":0.25},{"source":"Genetics","target":"Cardiometabolic","value":3,"curvature":0.25},{"source":"Genetics","target":"Germline Disease Risk","value":3,"curvature":0.25},{"source":"Genetics","target":"Pharmacogenetics","value":3,"curvature":0.25},{"source":"Genetics","target":"Nutritional Absorption","value":3,"curvature":0.25},{"source":"Genetics","target":"Epigenetic Age Clocks","value":3,"curvature":0.25},{"source":"Disease Risk","target":"Cancer","value":3,"curvature":0.25},{"source":"Emotional Well-being","target":"Depression","value":3,"curvature":0.25},{"source":"Emotional Well-being","target":"Anxiety","value":3,"curvature":0.25},{"source":"Emotional Well-being","target":"Happiness and Satisfaction","value":3,"curvature":0.25},{"source":"Cognitive Function","target":"Memory","value":3,"curvature":0.25},{"source":"Cognitive Function","target":"Focus and Attention","value":3,"curvature":0.25},{"source":"Cognitive Function","target":"Productivity","value":3,"curvature":0.25},{"source":"Physical Environment","target":"Air Quality","value":3,"curvature":0.25},{"source":"Physical Environment","target":"Water Quality","value":3,"curvature":0.25},{"source":"Physical Environment","target":"Allergen Exposure","value":3,"curvature":0.25},{"source":"Physical Environment","target":"Toxin Exposure","value":3,"curvature":0.25},{"source":"Physical Environment","target":"Bacterial Exposure","value":3,"curvature":0.25},{"source":"Social Environment","target":"Community","value":3,"curvature":0.25},{"source":"Social Environment","target":"Friends","value":3,"curvature":0.25},{"source":"Social Environment","target":"Family relationships","value":3,"curvature":0.25},{"source":"Social Environment","target":"Intimate relationships","value":3,"curvature":0.25},{"source":"Macronutrient","target":"Protein intake","value":3,"curvature":0.25},{"source":"Macronutrient","target":"Carbohydrate intake","value":3,"curvature":0.25},{"source":"Macronutrient","target":"Fat intake","value":3,"curvature":0.25},{"source":"Micronutrient","target":"Vitamins","value":3,"curvature":0.25},{"source":"Micronutrient","target":"Minerals","value":3,"curvature":0.25},{"source":"Micronutrient","target":"Omegas","value":3,"curvature":0.25},{"source":"Micronutrient","target":"Antioxidants","value":3,"curvature":0.25},{"source":"Micronutrient","target":"Organic Acids","value":3,"curvature":0.25},{"source":"Gut Health","target":"Microbiome Diversity","value":3,"curvature":0.25},{"source":"Gut Health","target":"Intestinal Wall Permeability","value":3,"curvature":0.25},{"source":"Gut Health","target":"Intestinal Inflammation","value":3,"curvature":0.25},{"source":"Allergies","target":"Antibody testing","value":3,"curvature":0.25}]}');


function $8153db3b88c6ca7d$export$7cffb1a5458f5da7(srcList) {
    return new Promise((resolve, reject)=>{
        const loadedLookup = {};
        let doneCount = 0;
        function onCompleteLoading() {
            doneCount++;
            if (doneCount === srcList.length) resolve(loadedLookup);
        }
        srcList.forEach(async (url)=>{
            try {
                loadedLookup[url] = await $8153db3b88c6ca7d$export$fe58198efe02b173(url);
                onCompleteLoading();
            } catch (e) {
                console.log(e);
                onCompleteLoading();
            }
        });
    });
}
function $8153db3b88c6ca7d$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        // Asynchronously load an image
        var image = new Image();
        image.crossOrigin = "Anonymous";
        image.addEventListener("load", function() {
            resolve(image);
        });
        image.addEventListener("error", function() {
            reject(`cannot load image ${src}`);
        });
        image.src = `${src}`;
    });
}


async function $2832fef2dd7941d5$export$569bc8ea84ae8301(urlPrefix = "") {
    const imgUrls = (0, (/*@__PURE__*/$parcel$interopDefault($ff619b5ad0e129c8$exports))).nodes.map((node)=>node.img).map((src)=>urlPrefix + src);
    const allImages = await (0, $8153db3b88c6ca7d$export$7cffb1a5458f5da7)(imgUrls);
    return allImages;
}
function $2832fef2dd7941d5$export$8e8d2f19323c0cd5() {
    const allNodesLookup = {};
    // make a lookup table for the nodes
    (0, (/*@__PURE__*/$parcel$interopDefault($ff619b5ad0e129c8$exports))).nodes.forEach((node)=>{
        const nodeInfo = {
            id: node.id,
            img: node.img,
            desc: node.desc,
            children: [],
            parent: null
        };
        allNodesLookup[nodeInfo.id] = nodeInfo;
    });
    // stitch nodes together
    const allNodesTree = (0, (/*@__PURE__*/$parcel$interopDefault($ff619b5ad0e129c8$exports))).links.reduce((arr, currLink, index)=>{
        // move nodes into node
        const sourceNode = allNodesLookup[currLink.source];
        const targetNode = allNodesLookup[currLink.target];
        targetNode.parent = sourceNode;
        sourceNode.children.push(targetNode);
        // add source node the record
        if (!arr.includes(sourceNode)) arr.push(sourceNode);
        return arr;
    }, []).filter((node)=>{
        // return the root node only
        return node.parent === null;
    });
    return allNodesTree;
}
function $2832fef2dd7941d5$export$381d74b3c096502d(treeNode, buildNode) {
    function buildNodeRecursively(nodeInfoArr, level, parentNodeCollection) {
        return nodeInfoArr.map((nodeInfo, index)=>{
            // this is the root node
            if (!parentNodeCollection) {
                const newNodeCollection = buildNode(nodeInfo, null, 0, index);
                buildNodeRecursively(nodeInfo.children, level + 1, newNodeCollection);
                return newNodeCollection;
            }
            // not the root collection
            const newNodeCollection = buildNode(nodeInfo, parentNodeCollection, level, index);
            buildNodeRecursively(nodeInfo.children, level + 1, newNodeCollection);
            return newNodeCollection;
        });
    // const nodeCollection =
    //   parentNodeCollection === undefined
    //     ? buildNode(nodeInfo, null, level)
    //     : parentNodeCollection;
    // // reached the bottom
    // if (nodeInfo.children.length === 0) return nodeCollection;
    // // build the children
    // nodeInfo.children.forEach((childrenNode) => {
    //   buildNode(childrenNode, nodeCollection, level);
    //   buildNodeRecursively(childrenNode, level + 1, nodeCollection);
    // });
    }
    return buildNodeRecursively(treeNode, 0);
}


function $ba15f7414b1a5fc0$export$d579faa0e3f25169(nodeCollection) {
    const nodes = $ba15f7414b1a5fc0$var$flattenNodes(nodeCollection, []);
    return {
        nodes: nodes
    };
}
function $ba15f7414b1a5fc0$export$8bdd57a6cc683237({ nodes: nodes }) {
    const tree = $ba15f7414b1a5fc0$var$createBaseQuadTreeCell({
        width: window.innerWidth,
        height: window.innerHeight
    });
    nodes.forEach((node)=>{
        $ba15f7414b1a5fc0$var$addToQuadTree(tree, node);
    });
    const collisionResults = [];
    nodes.forEach((node)=>{
        const result = $ba15f7414b1a5fc0$var$queryQuadTree(tree, {
            x: node.x,
            y: node.y,
            width: node.radius * 2,
            height: node.radius * 2
        });
        if (result.length > 1) collisionResults.push(result[1]);
    });
// console.log(collisionResults.length);
// const result = queryQuadTree(tree, {
//   x: window.innerWidth / 2,
//   y: window.innerHeight / 2,
//   width: 100,
//   height: 100,
// });
// result.forEach((item) => {
//   item.targetOpacity = 0.5;
// });
// console.log(nodes.length);
// console.log(result.length);
}
function $ba15f7414b1a5fc0$var$repelNodes(node1, node2) {}
function $ba15f7414b1a5fc0$var$flattenNodes(node, arr) {
    arr.push(node);
    // update the node collection
    node.nodes.forEach((node)=>{
        // if it were a node collection
        if (node.nodes) {
            $ba15f7414b1a5fc0$var$flattenNodes(node, arr);
            return;
        }
    });
    return arr;
}
function $ba15f7414b1a5fc0$var$createBaseQuadTreeCell(config) {
    return $ba15f7414b1a5fc0$var$createQuadTreeCell(0, 0, config.width, config.height, 0);
}
function $ba15f7414b1a5fc0$var$addToQuadTree(cell, node, splitThreshold = 4, maxLevel = 4) {
    const isAboveSplittingThreshold = cell.items.length >= splitThreshold;
    if (isAboveSplittingThreshold && cell.level <= maxLevel) {
        // split here
        $ba15f7414b1a5fc0$var$splitCellAndAdd(cell, node);
        return;
    }
    cell.items.push(node);
}
function $ba15f7414b1a5fc0$var$splitCellAndAdd(curr, node) {
    const halfWidth = curr.width / 2;
    const halfHeight = curr.height / 2;
    const childrenLevel = curr.level + 1;
    curr.children = {
        topLeft: $ba15f7414b1a5fc0$var$createQuadTreeCell(curr.x, curr.y, halfWidth, halfHeight, childrenLevel),
        topRight: $ba15f7414b1a5fc0$var$createQuadTreeCell(curr.x + halfWidth, curr.y, halfWidth, halfHeight, childrenLevel),
        bottomLeft: $ba15f7414b1a5fc0$var$createQuadTreeCell(curr.x, curr.y + halfHeight, halfWidth, halfHeight, childrenLevel),
        bottomRight: $ba15f7414b1a5fc0$var$createQuadTreeCell(curr.x + halfWidth, curr.y + halfHeight, halfWidth, halfHeight, childrenLevel)
    };
    curr.items.push(node);
    curr.items.forEach((item)=>{
        if (curr.children === undefined) return;
        if ($ba15f7414b1a5fc0$var$intersectsCircleRect(item, curr.children.topLeft)) {
            curr.children.topLeft.items.push(item);
            return;
        }
        if ($ba15f7414b1a5fc0$var$intersectsCircleRect(item, curr.children.topRight)) {
            curr.children.topRight.items.push(item);
            return;
        }
        if ($ba15f7414b1a5fc0$var$intersectsCircleRect(item, curr.children.bottomLeft)) {
            curr.children.bottomLeft.items.push(item);
            return;
        }
        if ($ba15f7414b1a5fc0$var$intersectsCircleRect(item, curr.children.bottomRight)) {
            curr.children.bottomRight.items.push(item);
            return;
        }
    });
}
function $ba15f7414b1a5fc0$var$createQuadTreeCell(x = 0, y = 0, width = 0, height = 0, level = 0) {
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        level: level,
        items: []
    };
}
function $ba15f7414b1a5fc0$var$queryQuadTree(cell, queryRect) {
    const reuslt = [];
    if ($ba15f7414b1a5fc0$var$doesFullyContainRect(queryRect, cell)) reuslt.push(...cell.items);
    else if ($ba15f7414b1a5fc0$var$intersectsRectRect(queryRect, cell)) {
        // this is not a leaf
        if (cell.children) {
            // test the different quardrant
            const topLeftResult = $ba15f7414b1a5fc0$var$queryQuadTree(cell.children.topLeft, queryRect);
            const topRightResult = $ba15f7414b1a5fc0$var$queryQuadTree(cell.children.topRight, queryRect);
            const bottomLeftResult = $ba15f7414b1a5fc0$var$queryQuadTree(cell.children.bottomLeft, queryRect);
            const bottomRightResult = $ba15f7414b1a5fc0$var$queryQuadTree(cell.children.bottomRight, queryRect);
            reuslt.push(...topLeftResult);
            reuslt.push(...topRightResult);
            reuslt.push(...bottomLeftResult);
            reuslt.push(...bottomRightResult);
            return reuslt;
        }
        for (const item of cell.items)if ($ba15f7414b1a5fc0$var$intersectsCircleRect(item, queryRect)) reuslt.push(item);
    }
    return reuslt;
}
function $ba15f7414b1a5fc0$var$doesFullyContainRect(rect, rect2) {
    return rect.x <= rect2.x && rect.y <= rect.y && rect.x + rect.width >= rect2.x + rect2.width && rect.y + rect.height >= rect2.y + rect2.height;
}
function $ba15f7414b1a5fc0$var$intersectsRectRect(rect, rect2) {
    // are the sides of one rectangle touching the other?
    if (rect.x + rect.width >= rect2.x && // r1 right edge past r2 left: ;
    rect.x <= rect2.x + rect2.width && // r1 left edge past r2 right: ;
    rect.y + rect.height >= rect2.y && // r1 top edge past r2 bottom
    rect.y <= rect2.y + rect2.height) // r1 bottom edge past r2 top
    return true;
    return false;
}
function $ba15f7414b1a5fc0$var$intersectsCircleRect(circle, rect) {
    const circleDistance = {
        x: Math.abs(circle.x - rect.x),
        y: Math.abs(circle.y - rect.y)
    };
    if (circleDistance.x > rect.width / 2 + circle.radius) return false;
    if (circleDistance.y > rect.height / 2 + circle.radius) return false;
    if (circleDistance.x <= rect.width / 2) return true;
    if (circleDistance.y <= rect.height / 2) return true;
    const cornerDistance_sq = circleDistance.x - rect.width / 2 ^ 2 + (circleDistance.y - rect.height / 2) ^ 2;
    return cornerDistance_sq <= (circle.radius ^ 2);
}


let $f43313d21d3fd8e2$var$imagePrefixURL = "";
//@ts-ignore
window.setupSuperpowerGraph = (element, imageAssetURLPrefix = "")=>{
    // inject the url here
    $f43313d21d3fd8e2$var$imagePrefixURL = imageAssetURLPrefix;
    (0, $ef69b262fafa6326$export$fa1ee8bd071b3aa0)({
        elm: element,
        init: $f43313d21d3fd8e2$var$init,
        update: $f43313d21d3fd8e2$var$update
    });
};
window.addEventListener("load", ()=>{
    const host = window.location.host;
    if (host.indexOf("localhost") !== -1 || host.indexOf("superpower-dev.netlify.app") !== -1) //@ts-ignore
    window.setupSuperpowerGraph(document.body, "https://daybreak-superpower.netlify.app/force-graph/images/");
});
// const nodeCollection = createNodeCollection({
//   radius: 100,
//   showChildrenLink: true,
//   isExpanded: true,
//   canToggleExpandState: false,
// });
function $f43313d21d3fd8e2$var$getDegree(rad) {
    return rad * 180 / Math.PI;
}
function $f43313d21d3fd8e2$var$getFullImageURL(src) {
    return $f43313d21d3fd8e2$var$imagePrefixURL + src;
}
const $f43313d21d3fd8e2$var$init = async ({ canvas: canvas, context: context })=>{
    const viewportAnchor = (0, $a55bec5aeea31c80$export$442d33069165dc4e)();
    viewportAnchor.x = canvas.width / 2;
    viewportAnchor.y = canvas.height / 2;
    const allImages = await (0, $2832fef2dd7941d5$export$569bc8ea84ae8301)($f43313d21d3fd8e2$var$imagePrefixURL);
    const mouse = (0, $adcfe21ca3ca1826$export$bf5b3774d3a1ba80)(canvas);
    const tree = (0, $2832fef2dd7941d5$export$8e8d2f19323c0cd5)();
    const nodeCollection = (0, $2832fef2dd7941d5$export$381d74b3c096502d)(tree, (nodeInfo, parentNode, level, index)=>{
        if (!parentNode) return (0, $f5869366c35a1053$export$e363dd855d5a0213)({
            x: canvas.width / 2,
            y: canvas.height / 2,
            radius: 100,
            showChildrenLink: true,
            isExpanded: true,
            canToggleExpandState: false,
            image: allImages[$f43313d21d3fd8e2$var$getFullImageURL(nodeInfo.img)]
        });
        const siblingCount = nodeInfo.parent?.children.length || 0;
        const parentAngle = $f43313d21d3fd8e2$var$getDegree(Math.atan2(parentNode.centerOffsetY, parentNode.centerOffsetX)) - 90;
        if (level === 1) {
            const angle = 360 * index / siblingCount - parentAngle;
            const dist = 200;
            const pos = (0, $28770b279d7ab5b1$export$edd0b2047cd8f3e)(dist, angle);
            return parentNode.createNodeCollection({
                centerOffsetX: pos.x,
                centerOffsetY: pos.y,
                radius: 50,
                isExpanded: false,
                canToggleExpandState: true,
                showChildrenLink: true,
                image: allImages[$f43313d21d3fd8e2$var$getFullImageURL(nodeInfo.img)],
                label: nodeInfo.id
            });
        }
        const levelFactor = level / 5;
        const limitedAngle = 270 * levelFactor;
        const angle = limitedAngle * index / siblingCount - limitedAngle / 2 - parentAngle;
        const dist = 100 * index / siblingCount + 100;
        const pos = (0, $28770b279d7ab5b1$export$edd0b2047cd8f3e)(dist, angle);
        return parentNode.createNodeCollection({
            centerOffsetX: pos.x,
            centerOffsetY: pos.y,
            radius: 40 * (1 - levelFactor),
            isExpanded: false,
            canToggleExpandState: true,
            showChildrenLink: true,
            image: allImages[$f43313d21d3fd8e2$var$getFullImageURL(nodeInfo.img)],
            label: nodeInfo.id
        });
    })[0];
    const collisionSystemInfo = (0, $ba15f7414b1a5fc0$export$d579faa0e3f25169)(nodeCollection);
    return {
        nodeCollection: nodeCollection,
        collisionSystemInfo: collisionSystemInfo,
        mouse: mouse,
        viewportAnchor: viewportAnchor
    };
};
const $f43313d21d3fd8e2$var$update = (canvasRenderer, state)=>{
    const { nodeCollection: nodeCollection, mouse: mouse, collisionSystemInfo: collisionSystemInfo, viewportAnchor: viewportAnchor } = state;
    (0, $adcfe21ca3ca1826$export$bb12a23115d1ed55)(mouse);
    (0, $a55bec5aeea31c80$export$b65f3899727324e3)(mouse, canvasRenderer, viewportAnchor);
    // render update
    (0, $f5869366c35a1053$export$fe599c3bcb8c2b1b)(nodeCollection, mouse, viewportAnchor);
    (0, $f5869366c35a1053$export$d16818ab5fd4fa71)(nodeCollection, canvasRenderer);
    (0, $f5869366c35a1053$export$23adae1c558f4ea5)(nodeCollection, canvasRenderer);
    (0, $ba15f7414b1a5fc0$export$8bdd57a6cc683237)(collisionSystemInfo);
};


//# sourceMappingURL=index.2bbada43.js.map
